<div class="navbar">
  <a
      class="back"
      fsNavBack>
    <mat-icon class="back-icon">
      keyboard_arrow_left
    </mat-icon>
  </a>
  <div
    class="left-actions"
    fsNavActions="left">
  </div>
  <div class="content">
    <div
      fsNavComponent="image"
      type="image">
    </div>
    <div>
      <div fsNavSupertitle></div>
      <!-- Controls that belong to the thing being NAMED sit on its name, not
           in the page's own toolbar — see NavService.titleTemplate. -->
      <div class="fs-row.gap-sm">
        <div fsNavTitle></div>
        @if (titleTemplate(); as template) {
          <div class="fs-row title-slot">
            <ng-container [ngTemplateOutlet]="template"></ng-container>
          </div>
        }
      </div>
      <div fsNavSubtitle></div>
    </div>
  </div>
  <div
    class="actions"
    fsNavActions="right">
  </div>
  <app-account-menu></app-account-menu>
</div>